export default __webpack_public_path__ + "static/assets/bd3bec8a8f45ebbf5e1d076b7c98c764.png";